import { render, staticRenderFns } from "./TableRates.vue?vue&type=template&id=c155ae68&"
import script from "./TableRates.vue?vue&type=script&lang=js&"
export * from "./TableRates.vue?vue&type=script&lang=js&"
import style0 from "./TableRates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports